export const addressHistoryQuestions = {
  addressHistory: {
    header: 'applicationForm.ADDRESS_HISTORY.confirm',
    empty: 'applicationForm.ADDRESS_HISTORY.noHistory',
    add: 'applicationForm.ADDRESS_HISTORY.addAddress',
  },
};
